import React from 'react';
import './Header.css'

const Header = () => {
    return (
        <div className="headerTitle">
            <h1 className="textStyle">Greatest Computer Programmers Of All Time</h1>
            <p className="dollerTitleStyle">Every Programmer Average Yearly Salary 200 Million</p>
        </div>
    );
};

export default Header;